// i18n area 'vms' — locale sk-SK (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.sk-SK.meta.json.
import type { enUS } from './vms'

export const skSK: typeof enUS = {
  vms: {
    spof: {
      title: 'Nezávislosť od uzla',
      single: 'Jediný bod zlyhania',
      alternativesNow: 'Alternatívy teraz',
      structural: 'Z konštrukcie',
      binding: 'Obmedzujúca podmienka',
      movableNow: 'Migrácia možná teraz',
    },
    title: 'Virtuálne stroje',
    migratingChip: 'Prebieha migrácia',
    templateChip: 'Šablóna',
    expendableTooltip: 'V degradovanom klastri je medzi prvými, ktoré sa zastavia, a po strate uzla sa už nemusí spustiť.',
    expendableHaTooltip: 'Kým je klaster zdravý, vždy sa reštartuje; v degradovanom klastri majú chránené VM prednosť — môže byť zastavená alebo zostať vypnutá, kým klaster nebude opäť celý, potom sa spustí sama.',
    viewDetails: 'Zobraziť podrobnosti',
    profileLegacy: 'Iný OS',
    hugePagesNone: 'Žiadne — bežná pamäť',
    hugePages2M: 'Stránky po 2 MiB',
    hugePages1G: 'Stránky po 1 GiB',
    searchPlaceholder: 'Hľadať podľa názvu',
    name: 'Názov',

    // Terminologia UNA (#94a): la phase si chiama 'Fase' ovunque — la
    // vecchia chiave 'state' è morta col polish della lista.
    vcpus: 'vCPU',
    memory: 'Pamäť',
    ipAddresses: 'IP adresy',
    noIp: 'Žiadna IP',
    authorityNode: 'Authority',
    authorityNextStart: 'priradí sa pri najbližšom spustení',
    scope: 'Scope',
    empty: 'Žiadne virtuálne stroje',
    loadError: 'Virtuálne stroje sa nepodarilo načítať — je backend TVirt dostupný?',
    filterOverlay: 'overlay sieť',
    filterDisk: 'disk',
    filterImage: 'obraz',
    filteredBy: 'Filtrované podľa: {kind}',
    filterPhase: 'Fáza',
    filterProtection: 'Ochrana',
    filterAll: 'Všetky',
    filterScopePlaceholder: 'Filtrovať podľa scopu',
    filtersToggle: 'Filtre',
    scopeTree: {
      title: 'Scopy',
      all: 'Celý klaster',
      noChildren: 'Tu nie sú žiadne pod-scopy',
      recursive: 'Zahrnúť potomkov',
      collapse: 'Zbaliť panel scopov',
      up: 'O úroveň vyššie',
      countTooltip: '{direct} VM v tomto scope · {total} vrátane potomkov'
    },

    // Il picker ISO a due passi (#85): prima il catalogo, poi le sue ISO.
    isoPicker: {
      catalog: 'Katalóg',
      unknownCatalog: 'Mimo viditeľných katalógov',
      noIsos: 'Žiadny pripravený obraz ISO v tomto katalógu'
    },
    actionsHeader: 'Akcie',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Hardvér',
      tags: 'Značky',
      age: 'Vek',
      disk: 'disk',
      disks: 'disky',
      empty: 'Žiadne šablóny — označte vypnutú VM ako šablónu alebo naklonujte nejakú VM ako šablónu.',
      clone: 'Klonovať / nasadiť',
      editTags: 'Upraviť značky',

      // Round K3 (#64): esporta il template come file .tvtpl del catalogo.
      exportAction: 'Exportovať do katalógu (.tvtpl)',
      exportTitle: 'Exportovať do katalógu',
      exportSubmit: 'Exportovať',
      exportError: 'Export zlyhal',
      exportHint: 'Šablóna sa zabalí do archívu .tvtpl (hardvérový manifest + každý disk sploštený do qcow2) ako nový súbor šablóny VM vo zvolenom katalógu. NIC, médiá CD/DVD a cloud-init sa neprenášajú — špecifikácia formátu uvádza každé zámerné vynechanie.',
      exportName: 'Názov súboru',
      exportNameHint: 'Prázdne = <template>-export-<n>',
      exportStorageDefault: 'Úložisko metadát šablóny',

      // Importa da catalogo (Luca 2026-08-03): l'ingresso in toolbar del tab
      // Template — il backend K3/K4 copre tutti i formati vm-template, la
      // scelta è il FILE (il formato viaggia in sola lettura).
      importAction: 'Importovať z katalógu',
      importTitle: 'Importovať z katalógu',
      importHint: 'Súbor šablóny VM v stave ready zo zvoleného katalógu sa stane šablónou inventára: formát súboru (tvtpl, ova, ovf alebo holý qcow2) sám rozhodne, ako sa importuje — vy vyberáte iba súbor.',
      importFile: 'Súbor katalógu',
      importFileHint: 'Importujú sa iba súbory v stave ready — súbor uprostred uploadu importovať nemožno',
      importNoFiles: 'V tomto katalógu nie je žiadny súbor šablóny VM v stave ready — najprv nejaký nahrajte alebo exportujte'
    },
    templateDetail: {
      quickDeploy: 'Kompatibilita s QuickDeploy',
      quickDeployNone: 'Nedeklarovaná',
      quickDeployHint: 'Deklarujte ju len vtedy, ak golden obraz obsahuje cloud-init (Linux) alebo cloudbase-init po sysprep /generalize (Windows): platforma deklarácii dôveruje a nikdy sa nepozerá dovnútra hosťa.',
      notFound: 'Šablóna sa nenašla',
      frozen: 'Hardvérová konfigurácia je zmrazená: ak ju chcete zmeniť, preveďte šablónu späť na VM. Názov, poznámky a značky zostávajú upraviteľné.',
      storage: 'Úložisko',
      size: 'Veľkosť',
      configTitle: 'Konfigurácia (zmrazená)',
      usbClasses: 'Vyžadované triedy USB',
      gpuClasses: 'Vyžadované triedy GPU'
    },
    sharedDisksTab: {
      title: 'Zdieľané disky',
      sharing: 'Zdieľanie',
      sharingNone: 'Jedno pripojenie',
      sharingMultiwriter: 'Zdieľaný zápis (multiwriter)',
      sharingReadonly: 'Zdieľané iba na čítanie',
      usedBy: 'Používa',
      attachedTo: 'Pripojený k',
      notAttached: 'Pripojený k žiadnej VM',
      changeSharing: 'Zmeniť režim zdieľania',
      changeSharingTitle: 'Režim zdieľania',
      changeSharingLocked: 'Režim sa mení iba kým disk nepoužíva žiadna VM',
      sharingChanged: 'Režim zdieľania aktualizovaný.',
      lun: 'Celý LUN',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Sériové číslo',
      antiAffinityWarning: 'Dvaja alebo viacerí členovia bežia na tom istom uzle bez pravidla anti-afinity: výpadok jedného uzla ich zhodí všetkých',
      antiAffinityCreate: 'Vytvoriť pravidlo',
      createSourceLun: 'Prevziať celý LUN targetu',
      createLunNumber: 'Číslo LUN (id namespace pri NVMe)',
      createLunHint: 'Nič sa nealokuje: veľkosť sa pri prevzatí prečíta zo zariadenia',
      noPr: 'V tomto vydaní nie sú SCSI-3 persistent reservations: Windows Failover Cluster s klasickým zdieľaným diskom nie je validovaný; clustre koordinujúce sa cez sieť (GFS2/OCFS2, RHEL HA, shared-disk databázy) áno'
    },
    unusedDisksTab: {
      title: 'Nepoužité disky',
      attach: 'Pripojiť k VM',
      attachTitle: 'Pripojiť k VM',
      vm: 'Virtuálny stroj',
      noVms: 'Žiadne dostupné VM',
      noSlots: 'Na tejto VM nie je žiadny voľný slot',

      // Crea disco standalone (#87): tornato dall'Inventario pensionato, ora
      // con campo scope ESPLICITO (non c'è una VM da cui ereditare).
      create: 'Vytvoriť disk',
      createTitle: 'Vytvoriť disk',
      createSourceBlank: 'Prázdny disk',
      createSourceImage: 'Z obrazu v katalógu',
      createImage: 'Obraz',
      createImageEmpty: 'Vo viditeľných katalógoch nie je žiadny pripravený obraz šablóny VM',
      createSizeFromImageHint: 'Predvyplnené virtuálnou veľkosťou obrazu — môže iba rásť',

      // #107 (DISTRUTTIVO, ratificato): qcow2 → catalog file vm-template
      // sullo stesso storage, zero byte copiati — il disco cessa di esistere.
      convert: 'Konvertovať na šablónu VM…',
      convertOnlyQcow2: 'Konvertujú sa iba disky qcow2 — raw nie je registrovateľný formát šablóny',
      convertTitle: 'Konvertovať na šablónu VM',
      convertSubmit: 'Konvertovať (zničí disk)',
      convertError: 'Konverziu sa nepodarilo spustiť',
      convertWarning: 'DEŠTRUKTÍVNE: disk sa stane súborom šablóny VM vo zvolenom katalógu — rovnaké úložisko, nula skopírovaných bajtov — a PRESTANE EXISTOVAŤ ako disk. Cesta späť neexistuje, iba vytvorenie nového disku zo šablóny.',
      convertNameHint: 'Názov súboru katalógu — predvolene názov samotného disku',
      convertConfirm: 'Rozumiem: disk bude zničený',
      convertStarted: 'Konverzia sa spustila — šablóna sa v katalógu objaví po dokončení úlohy.',
      storageLockHint: 'Úložisko sa mení iba akciou Presunúť',
      source: 'Pôvod',
      sourceClone: 'Klon iného disku',
      sourceCloneLinked: 'Linked klon iného disku',
      sourceImage: 'Vytvorený z obrazu',
      sourceBlank: 'Vytvorený prázdny',
      allocated: 'Alokované / virtuálna veľkosť',
      observedAt: 'Pozorované',
      snapshots: 'Snímky',
      snapshotsEmpty: 'Žiadne snímky'
    },
    phase: {
      defined: 'Nikdy nezapnutá',
      starting: 'Spúšťa sa',
      running: 'Spustená',
      stopping: 'Zastavuje sa',
      stopped: 'Vypnutá',
      paused: 'Pozastavená',
      failed: 'Zlyhala',
      deleting: 'Odstraňuje sa'
    },
    stopCause: {
      'api': 'Zastavená platformou TVirt (akcia alebo API)',
      'guest-shutdown': 'Shutdown spustený hosťovským operačným systémom',
      'crash': 'Crash hosťa',
      'qemu-exit': 'Proces QEMU sa neočakávane ukončil',
      'host-reboot': 'Uzol sa reštartoval',
      'migrated': 'Migrovaná na iný uzol',
      'fenced': 'Ukončená fencingom HA (uzol sa vrátil)'
    },
    detail: {
      notFound: 'Virtuálny stroj sa nenašiel',
      details: 'Podrobnosti',
      id: 'ID',
      scope: 'Scope',
      profile: 'Hardvérový profil',
      firmware: 'Firmvér',
      firmwareFile: 'Verzia firmvéru UEFI',
      firmwareUpdate: 'Aktualizácia k dispozícii',
      firmwareUpdateHint: 'Platforma prináša novší firmvér UEFI. Aktualizácia nie je nikdy automatická: aplikuje sa pri vypnutej VM, keď sa rozhodnete vy.',
      arch: 'Architektúra',
      node: 'Uzol',
      bootOrder: 'Poradie zavádzania',
      agent: 'Stav agenta',
      agentConnected: 'Pripojený',
      agentNotConnected: 'Nepripojený',
      protected: 'Chránená',
      linkedClones: 'Linked klony',
      restartPolicy: 'Politika reštartu',
      preferredNode: 'Preferovaný uzol',
      noPreference: 'Žiadna preferencia (automatický placement)',
      preferNodes: 'Preferované značky uzlov',
      requireNodes: 'Povinné značky uzlov',
      noPlacementTags: 'Žiadne',
      placementTag: 'Značka',
      placementValue: 'Hodnota',
      placementAddTag: 'Pridať značku',
      proximityHa: 'HA TVirt Proximity',
      proximityHaRestarts: 'reštarty HA',
      proximityHaGaveUp: 'crash loop — HA to vzdalo',
      failoverProtection: 'Ochrana v degradovanom klastri',
      protectionProtected: 'Chránená',
      protectionExpendable: 'Obetovateľná pri degradácii',
      protectionInherit: 'Dediť',
      lastStop: 'Posledné zastavenie',
      yes: 'Áno',
      no: 'Nie',
      tabOverview: 'Prehľad',
      tabSnapshots: 'Snímky',
      tabBackups: 'Zálohy',
      hardware: 'Hardvér',
      name: 'Názov',
      hwSystem: 'Systém',
      hwCpu: 'CPU',
      hwMemory: 'Pamäť',
      hwBoot: 'Zavedenie',
      hwIdentity: 'Identita',
      hwCluster: 'Klaster a agent',
      cpuTopology: 'Topológia CPU',
      cpuModel: 'Model CPU',
      cpuLimit: 'Limit CPU',
      cpuWeight: 'Váha CPU',
      cpuNested: "Vnorená virtualizácia",
      cpuNestedHint: "Sprístupní hosťovi vmx/svm (iba s modelom CPU host). Pri bežiacom VM sa zmena prejaví pri najbližšom power cycle (PendingRestart); umiestnenie pripúšťa len uzly so zapnutým nested.",
      unlimited: 'Neobmedzené',
      memory: 'Pamäť',
      balloon: 'Balloon',
      hugePages: 'Obrovské stránky',
      hugePagesTradeoff: 'Menej práce s prekladom adries a pamäť, ktorá nikdy neskončí na disku; výmenou za to zostáva rezervácia zamknutá na uzle, kým je VM zapnutá, pamäť sa už nededuplikuje a spustenie zlyhá, ak uzol nemá dosť voľných stránok.',
      disks: 'Disky',
      cdroms: 'Mechaniky CD/DVD',
      nics: 'Sieťové rozhrania',
      slot: 'Slot',
      disk: 'Disk',
      encrypted: 'Šifrovaný',
      image: 'Obraz',
      emptyDrive: 'Prázdna mechanika',
      emptyOption: '(prázdne)',
      network: 'Sieť',
      mac: 'MAC',
      connected: 'Pripojené',
      unplugged: 'Odpojené',
      noDevices: 'Žiadne',
      screenshot: 'Snímka obrazovky',
      capturedAt: 'Zachytené o',
      noCapture: 'Žiadna snímka obrazovky',
      snapshotName: 'Názov',
      snapshotCreated: 'Vytvorená',
      snapshotMemory: 'Vrátane pamäte',
      noSnapshots: 'Žiadne snímky',
      pendingRestart: 'Čakajúce zmeny: aplikujú sa pri najbližšom power cycle.',
      applied: 'aplikované',
      appliedHint: 'VM beží s touto hodnotou — tá nakonfigurovaná sa aplikuje pri najbližšom power cycle.',
      actionError: 'Akcia zlyhala',
      actionStillRunning: 'Akcia stále beží — jej výsledok zatiaľ nie je známy',
      tabConsole: 'Konzola',
      consoleConnect: 'Pripojiť',
      consoleDisconnect: 'Odpojiť',
      consoleConnecting: 'Pripája sa…',
      consoleReconnecting: 'Pripája sa…',
      consoleUnavailable: 'Konzola je k dispozícii, keď je VM spustená alebo pozastavená.',
      consoleError: 'Pripojenie ku konzole zlyhalo',
      consoleTaken: 'Reláciu konzoly prevzal používateľ {user}',
      consoleReconnect: 'Znova pripojiť',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Podržať {key}',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Otvoriť na celú obrazovku na novej karte',
      consoleLoadFailed: 'VM sa nenašla alebo nedostatočné oprávnenia',
      consoleClose: 'Zavrieť',
      tabStats: 'Štatistiky',
      tabTasks: 'Úlohy',
      tabLogs: 'Logy',
      statsCpu: 'CPU',
      statsMemory: 'Pamäť',
      statsDisk: 'Diskové I/O',
      statsRange: 'Rozsah',
      statsNoData: 'Vo zvolenom rozsahu nie sú žiadne dáta — štatistiky sa vzorkujú, kým VM beží.',
      statsError: 'Štatistiky sa nepodarilo načítať',
      cpuUsage: 'Využitie',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Použitá',
      memGuestAvailable: 'Dostupná (hosť)',
      schema: 'Schéma',
      consoleProtocol: 'Konzola',
      agentEnabled: 'Guest agent',
      metadataStorage: 'Úložisko metadát',
      startupOnBoot: 'Spustenie pri zavedení',
      startupOrder: 'Poradie spúšťania',
      startupDelay: 'Oneskorenie spustenia',
      seconds: 's',
      enabled: 'Povolené',
      disabled: 'Zakázané'
    },
    actionsAvailable: 'Dostupné akcie',
    actions: {
      start: 'Spustiť',
      stop: 'Zastaviť',
      pause: 'Pozastaviť',
      resume: 'Pokračovať',
      reset: 'Resetovať',
      migrate: 'Migrovať',
      clone: 'Klonovať',
      moveStorage: 'Presunúť do úložiska…',
      moveScope: 'Presunúť do scopu…',
      openConsole: 'Otvoriť konzolu',
      forceStop: 'Vypnúť natvrdo',
      markTemplate: 'Označiť ako šablónu',
      unmarkTemplate: 'Previesť späť na VM',
      error: 'Akciu sa nepodarilo vykonať'
    },
    cordon: {
      confirmTitle: 'Uzol je v režime údržby',
      confirmHint:
        'Kordón sa nedá znížiť, kým je store klastra nedostupný. Potvrdením vyhlasujete, že to viete: VM sa tam aj tak zapne a súhlas zostane zaznamenaný na úlohe.',
      confirm: 'Aj tak zapnúť'
    },
    markTemplate: {
      confirmTitle: 'Označiť {name} ako šablónu?',
      confirmBody: 'Konfigurácia sa zmrazí a VM sa už nebude dať zapnúť — iba klonovať alebo previesť späť na VM. Názov, poznámky a značky zostávajú upraviteľné.',
      confirm: 'Označiť ako šablónu',
      moved: '{name} je teraz šablóna — presunula sa na kartu Šablóny.'
    },
    unmarkTemplate: {
      confirmTitle: 'Previesť {name} späť na VM?',
      confirmBody: 'Šablóna sa opäť stane bežnou VM: bude sa dať upravovať aj spúšťať (najbližšie spustenie ju umiestni na uzol).',
      confirm: 'Previesť na VM',
      moved: '{name} je opäť virtuálny stroj — presunul sa na kartu Virtuálne stroje.'
    },

    // Round #123: riferimento a nodo per TAG (selettore #106) nei dialog
    // di start e migrazione — anteprima dell'insieme risolto inclusa.
    nodeByTag: {
      label: 'Podľa značky uzla',
      hint: 'značka=hodnota, oddelené čiarkami (v AND): decider vyberá spomedzi zodpovedajúcich uzlov',
      invalid: 'Neplatný formát — použite značka=hodnota, oddelené čiarkami',
      resolved: 'Zodpovedajúci členovia: {nodes}'
    },
    migrate: {
      title: 'Live migrácia',
      submit: 'Migrovať',
      target: 'Cieľový uzol',
      auto: 'Automaticky (Proximity)',
      hint: 'VM sa presunie bez power cycle. Každé úložisko, ktorého sa dotýka, musí byť zdieľané; pozastavená VM migruje pozastavená.',
      error: 'Migrácia bola odmietnutá'
    },
    moveStorage: {
      title: 'Presunúť do úložiska',
      submit: 'Presunúť',
      target: 'Cieľové úložisko',
      noTargets: 'Žiadne úložisko neprijíma disky',
      hint: 'Všetky disky vypnutej VM sa presunú do zvoleného úložiska, jeden po druhom, so zachovaním svojho id — tie, ktoré už sú v cieli, sa preskočia. Priebeh žije na stránke úloh.',
      error: 'Presun bol odmietnutý'
    },
    moveScope: {
      title: 'Presunúť do scopu',
      submit: 'Presunúť',
      target: 'Cieľový scope',
      hint: 'VM zmení scope okamžite — id a disky zostávajú, jej owned disky ju nasledujú a môže zostať zapnutá. Teraz žije v {scope}. So scopom sa mení aj to, kto ju vidí.',
      error: 'Zmena scopu bola odmietnutá'
    },
    start: {
      title: 'Spustiť VM',
      submit: 'Spustiť',
      target: 'Cieľový uzol',
      auto: 'Automaticky (odporúčané)',
      recommended: 'odporúčané',
      hint: 'Vyberte cieľový uzol alebo nechajte Proximity rozhodnúť spomedzi platných kandidátov. Uzly, ktoré ju nemôžu hostiť, sú zakázané spolu s dôvodom.',
      error: 'VM sa nepodarilo spustiť'
    },
    console: {
      media: 'Mechaniky CD/DVD',
      mediaGuestToolsHint: 'Obsahuje TVirt Guest Tools — priamo tu ich môžete vysunúť alebo odobrať mechaniku',
      slotOpsDeferred: 'Na tomto profile sa pridanie a odobratie mechaník aplikuje pri najbližšom power cycle (zmeny média sú okamžité).',
      mountGuestTools: 'Vložiť TVirt Guest Tools',
      ejectGuestTools: 'Vysunúť TVirt Guest Tools',
      bootOrder: 'Poradie zavádzania',
      bootOrderHint: 'Nové poradie sa uloží okamžite a aplikuje sa pri najbližšom power cycle — relácia konzoly zostáva pripojená.'
    },
    snapshots: {
      create: 'Vytvoriť snímku',
      createTitle: 'Vytvoriť snímku',
      createSubmit: 'Vytvoriť',
      name: 'Názov',
      nameHint: 'Písmená, číslice, bodka, pomlčka, podčiarkovník.',
      consistencyHint: 'Konzistencia je automatická: keď guest agent odpovedá, zmrazí súborové systémy; inak sa VM okolo snímky na okamih pozastaví.',
      memory: 'Zahrnúť pamäť',
      memoryHint: 'Zachytí živú RAM: po obnovení VM pokračuje v behu. Vyžaduje, aby boli všetky disky qcow2.',
      currentChip: 'Ste tu',
      revert: 'Obnoviť',
      revertTitle: 'Obnoviť {name}?',
      revertBody: 'Disky sa vrátia do stavu snímky; všetko, čo sa stalo potom, sa stratí. Snímka len diskov vyžaduje zastavenú VM.',
      delete: 'Odstrániť',
      deleteTitle: 'Odstrániť snímku {name}?',
      deleteBody: 'Bod obnovenia zmizne; obsah diskov zostáva nedotknutý.',
      deleteMergeHint: 'Jeho delta sa zlúči do {children}: každý neskorší bod obnovenia zostáva platný.',
      deleteDuplication: 'Prijímam duplikáciu',
      deleteDuplicationHint: 'Delta sa skopíruje do každého z {count} čitateľov (potomkovia snapshotu a, ak je tento aktuálny, aktívna hlava): obsadené miesto môže rásť namiesto klesať.',
      error: 'Operácia so snímkou bola odmietnutá'
    },
    clone: {
      title: 'Klonovať VM',
      submit: 'Klonovať',
      name: 'Názov kópie',
      storage: 'Cieľové úložisko diskov',
      sameStorage: 'Rovnaké ako zdroj',
      full: 'Úplná kópia',
      fullHint: 'Skopíruje každý bajt a pretrhne väzbu na zdrojové disky. Predvolený je linked klon: okamžitý, ale pripútaný k zdroju (iba qcow2).',
      hint: 'Klon si zachováva konfiguráciu a firmvér zdroja; MAC adresy a identita TPM sú nové.',
      markAs: 'Typ klonu',
      markAsInheritVm: 'Ako zdroj (VM)',
      markAsInheritTemplate: 'Ako zdroj (šablóna)',
      markAsVm: 'Virtuálny stroj',
      markAsTemplate: 'Šablóna',
      markAsHintVm: 'Voľbou Šablóna povýšite kópiu v jednom kroku.',
      markAsHintTemplate: 'Voľbou Virtuálny stroj nasadíte z tejto šablóny v jednom kroku.',
      error: 'Klonovanie bolo odmietnuté'
    },
    bulk: {
      selected: 'vybrané',
      deleteTitle: {
        one: 'Odstrániť {count} vybranú VM?',
        few: 'Odstrániť {count} vybrané VM?',
        many: 'Odstrániť {count} vybranej VM?',
        other: 'Odstrániť {count} vybraných VM?'
      },
      deleteBody: 'Každá VM prechádza tými istými poistkami ako samostatné odstránenie; odmietnutia sa hlásia za každú položku.',
      done: 'prijaté',
      refused: 'odmietnuté'
    },
    delete: {
      button: 'Odstrániť',
      confirmTitle: 'Odstrániť {name}?',
      confirmBody: 'Virtuálny stroj a disky v jeho vlastníctve budú odstránené. Táto operácia sa nedá vrátiť späť.',
      keepDisks: 'Ponechať disky',
      keepDisksHint: 'Disky vytvorené spolu s VM zostanú vo svojom úložisku ako samostatné disky.',
      confirm: 'Odstrániť',
      cancel: 'Zrušiť',
      error: 'Odstránenie zlyhalo',
      blockedPhase: 'Najprv VM zastavte',
      blockedProtected: 'VM je chránená — najprv odoberte ochranu',
      blockedDeleting: 'Odstraňovanie už prebieha'
    },
    logs: {
      title: 'Logy',
      subtitle: 'Štruktúrované rámce logu z úloh, ktoré cielia na túto VM',
      when: 'Kedy',
      task: 'Úloha',
      level: 'Úroveň',
      message: 'Správa',
      empty: 'Zatiaľ žiadne logy',
      loadError: 'Logy sa nepodarilo načítať — je backend TVirt dostupný?'
    },
    stop: {
      title: 'Zastaviť virtuálny stroj',
      modeGraceful: 'Graceful vypnutie',
      modeGracefulHint: 'Hosťovský operačný systém je požiadaný, aby sa vypol prirodzene (ACPI); ak žiadosť ignoruje, po timeoute nasleduje vypnutie natvrdo.',
      modeForced: 'Vypnutie natvrdo',
      modeForcedHint: 'Okamžite odpojí napájanie — ako vytiahnutie zástrčky.',
      timeout: 'Fallback timeout (sekundy)',
      timeoutHint: 'Ako dlho sa čaká na hosťa, kým sa vypnutie vynúti'
    },

    // Il menu del bottone split di creazione (Luca 2026-07-23): "Da zero" apre
    // il wizard, le altre due voci sono stub di roadmap.
    createFromScratch: 'Od nuly',
    createFromTemplate: 'Zo šablóny',
    createQuickDeploy: 'TVirt QuickDeploy',

    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Spustiť deploy',
      error: 'Deploy zlyhal',
      compatNote: 'QuickDeploy vyžaduje šablónu kompatibilnú s QuickDeploy: platforma pri prvom spustení prispôsobí hosťa (sieť, doména, aktivácia).',
      template: 'Šablóna',
      noTemplates: 'Žiadna šablóna zatiaľ nedeklaruje kompatibilitu s QuickDeploy — deklarujte ju v záložke Šablóny (Linux s cloud-init, Windows s cloudbase-init po sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Názov hostiteľa',
      hostnameHint: 'Názov hostiteľa alebo FQDN; prázdne = názov VM (Windows: najviac 15 znakov)',
      ip: 'IP adresa',
      ipHint: 'Host a prefix, napr. 192.168.122.101/24; prázdne = DHCP',
      gateway: 'Brána',
      dns: 'DNS servery',
      dnsHint: 'Najviac tri, oddelené čiarkou',
      count: 'Inštancie',
      countHint: 'Viac než jedna: pomenované <názov>-1…-N, iba DHCP',
      user: 'Používateľ',
      userHint: 'Prázdne = predvolený používateľ obrazu (Linux) alebo Administrator (Windows)',
      password: 'Heslo',
      passwordHint: 'Zapíše sa do vygenerovanej user-data, ktorú platforma potom deklaruje ako tajnú: nikto ju už neprečíta',
      sshKeys: 'Verejné kľúče SSH',
      sshKeysHint: 'Jeden na riadok (ssh-ed25519 AAAA… komentár)',
      productKey: 'Product key Windows',
      kmsServer: 'Server KMS',
      kmsHint: 'Host alebo host:port — vyžaduje product key (klientsky kľúč KMS)',
      adDomain: 'Pripojiť k doméne Active Directory',
      adDomainHint: 'Prázdne = bez pripojenia k doméne',
      adUser: 'Účet na pripojenie',
      adPassword: 'Heslo účtu na pripojenie',
      adOu: 'Cieľová OU (voliteľné)',
      advanced: 'Rozšírené: surové dokumenty',
      userData: 'user-data (surová)',
      userDataHint: 'Nahrádza vygenerovanú user-data: používateľ, heslo, kľúče a polia Windows vyššie musia zostať prázdne',
      networkConfig: 'network-config (surová)',
      networkConfigHint: 'Nahrádza vygenerovanú sieť: IP, brána a DNS vyššie musia zostať prázdne',
      secret: 'Považovať surovú user-data za tajnú',
      secretHint: 'Označená ako tajná, API ju už nikomu nevracia a v Checkpointe cestuje zapečatená masterpass',
      startNow: 'Spustiť ihneď',
      startNowHint: 'Každá inštancia sa spustí hneď po definovaní; seed vzniká pri tomto spustení'
    },

    create: {
      nicAttachmentNetwork: 'Logická sieť (fabric)',
      nicNetwork: 'Logická sieť',
      nicNetworkHint: 'ODPORÚČANÁ cesta (F3): vNIC sa realizuje na ODVODENOM bridgi obsluhujúceho uzla — bridge sa rodí pri explicitnom apply fabric a štart na uzle, ktorý ho ešte nenesie, odmietne hovoriac. Keď odíde posledná referencia flotily, bridge pri najbližšom apply vypadne.',
      button: 'Vytvoriť VM',
      title: 'Vytvoriť virtuálny stroj',
      dialogTitle: 'Vytvoriť virtuálny stroj',
      stepGeneral: 'Všeobecné',
      stepGeneralHint: 'Názov a profil',
      stepCompute: 'CPU a RAM',
      stepComputeHint: 'Topológia a veľkosť',
      stepDisks: 'Disky',
      stepDisksHint: 'Vytvoriť alebo pripojiť',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Mechaniky a médiá',
      stepNetwork: 'Sieť',
      stepNetworkHint: 'NIC: trunk alebo bridge',
      stepSummary: 'Súhrn',
      stepSummaryHint: 'Skontrolovať a vytvoriť',
      name: 'Názov',
      nameHint: 'Malé písmená, číslice a pomlčky (DNS-1123)',
      nextButton: 'Ďalej',
      prevButton: 'Späť',
      submitButton: 'Vytvoriť',
      creating: 'Vytvára sa…',
      sockets: 'Sockety',
      cores: 'Jadrá na socket',
      threads: 'Vlákna na jadro',
      totalVcpus: 'vCPU spolu',
      memoryGib: 'Pamäť (GiB)',
      cpuModelHint: '\'host\' sprístupní CPU hostiteľa',
      cpuLimitHint: 'Strop v jadrách hostiteľa — prázdne = bez limitu',
      cpuNestedHint: "Sprístupní hosťovi vmx/svm, aby mohol bežať vlastný hypervízor — vyžaduje model CPU host a uzol so zapnutým nested",
      newDisk: 'Nový disk',
      attachDisk: 'Pripojiť existujúci disk',
      diskStorage: 'Úložisko',
      diskSize: 'Veľkosť (GiB)',
      diskSelect: 'Disk',
      addDisk: 'Pridať disk',
      addCdrom: 'Pridať mechaniku CD/DVD',
      addNic: 'Pridať sieťové rozhranie',
      remove: 'Odobrať',
      slotLimit: 'Dosiahnutý limit slotov',
      cdromImage: 'Obraz (ak chýba, mechanika bude prázdna)',
      nicAttachment: 'Pripojenie',
      nicAttachmentTrunk: 'Overlay trunk',
      nicAttachmentBridge: 'Hostiteľský bridge',
      nicUntagged: 'Untagged overlay',
      nicUntaggedNone: 'Žiadna (iba tagged)',
      nicTrunkHint: 'Aspoň jedna strana: untagged overlay a/alebo tagged VLAN mapovania — VM môže bežať iba na hostiteľoch, ktorých deklaruje každá referencovaná overlay sieť',
      nicTaggedVlan: 'VLAN ID',
      nicTaggedOverlay: 'Overlay sieť',
      addTagged: 'Pridať tagged VLAN',
      nicBridge: 'Názov hostiteľského bridge',
      nicBridgeHint: 'NM bridge podľa názvu — VM môže bežať iba na serveroch, ktorých hostiteľská sieť deklaruje tento bridge',
      nicMac: 'MAC (automaticky, ak prázdne)',
      noDisksHint: 'Žiadne disky: VM bude mať iba mechaniky CD/DVD, ktoré pridáte.',
      noCdromsHint: 'Žiadna mechanika CD/DVD: pridajte jednu, ak chcete zaviesť systém z obrazu ISO.',
      mountGuestTools: 'Vložiť TVirt Guest Tools pri prvom spustení',
      mountGuestToolsHint: 'Vloží ISO s virtio ovládačmi a guest agentom do prázdnej mechaniky CD (pridá sa, ak treba) — inštalátor Windows ich potrebuje, aby videl svoje disky.',
      noNicsHint: 'Žiadne sieťové rozhrania: VM sa spustí bez pripojenia.',
      taggedMappings: 'Tagged VLAN mapovania',
      summaryDevices: 'Zariadenia',
      bootOrderTitle: 'Poradie zavádzania',
      bootOrderHint: 'Poradie zmeníte ťahaním — vyhráva prvé zavediteľné zariadenie; NIC zavádzajú PXE',
      bootOrderUp: 'Posunúť vyššie',
      bootOrderDown: 'Posunúť nižšie',
      createError: 'Vytvorenie zlyhalo'
    },
    edit: {
      button: 'Upraviť',
      title: 'Upraviť virtuálny stroj',
      cancel: 'Zrušiť',
      save: 'Uložiť',
      error: 'Úprava zlyhala',
      modelStoppedOnly: 'Meniteľné iba pri vypnutej VM',
      firmwareStoppedOnly: 'Firmvér možno meniť iba pri vypnutej VM — pri najbližšom spustení sa stroj zavedie s novým firmvérom a premenné UEFI zostávajú',
      hugePagesStoppedOnly: 'Meniteľné iba pri vypnutej VM — pri najbližšom spustení sa pamäť vytvorí na novom backingu',
      runningHint: 'Zmeny sa aplikujú pri najbližšom power cycle',
      sectionCpu: 'CPU',
      sectionMemory: 'Pamäť',
      sectionPolicy: 'Politiky'
    },
    devices: {
      networkChip: 'sieť fabric',
      title: 'Zariadenia',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Pridať USB zariadenie',
      addUsbTitle: 'Vyžiadať triedu USB zariadení',
      usbClassHint:
        'VM žiada TRIEDU USB zariadení (hodnotu značky usb-device), nikdy konkrétne zariadenie: pri spustení sa na uzle vyberie a zarezervuje konkrétne voľné zariadenie. Registrované zariadenia označte značkami v časti Klaster › Zdroje USB a PCIe.',
      usbTag: 'Značka (usb-device)',
      usbValue: 'Hodnota triedy',
      noUsbTags: 'Žiadne značky usb-device — vytvorte jednu a označte registrované zariadenia v časti Klaster › Zdroje USB a PCIe.',
      noUsbValues: 'Táto značka zatiaľ nemá deklarované hodnoty.',
      usbEmpty: 'Žiadne požiadavky na USB — pridajte triedu na passthrough zariadenia pri spustení.',
      usbClassChip: 'trieda',
      usbPortChip: 'port',
      usbUnclaimed: 'Žiadne zarezervované zariadenie — vyrieši sa pri spustení VM.',
      addGpu: 'Pridať GPU',
      addGpuTitle: 'Vyžiadať triedu GPU',
      gpuClassHint:
        'VM žiada TRIEDU GPU (hodnotu značky gpu-device), nikdy konkrétnu kartu: pri spustení sa na uzle vyberie a zarezervuje konkrétna voľná karta a SPOLU s ňou prechádza celá jej skupina IOMMU. Registrované GPU označte značkami v časti Klaster › Zdroje USB a PCIe.',
      gpuTag: 'Značka (gpu-device)',
      gpuValue: 'Hodnota triedy',
      noGpuTags: 'Žiadne značky gpu-device — vytvorte jednu a označte registrované GPU v časti Klaster › Zdroje USB a PCIe.',
      noGpuValues: 'Táto značka zatiaľ nemá deklarované hodnoty.',
      gpuEmpty: 'Žiadne požiadavky na GPU — pridajte triedu na passthrough karty pri spustení.',
      gpuClassChip: 'trieda',
      gpuGroupChip: 'skupina IOMMU ×',
      gpuUnclaimed: 'Žiadna zarezervovaná karta — vyrieši sa pri spustení VM.',
      gpuPowerCycle: 'Žiadny hotplug GPU — zmeny platia od najbližšieho power cycle (PendingRestart)',
      actions: 'Akcie',
      attachDisk: 'Pridať disk',
      attachDiskTitle: 'Pridať disk',
      attach: 'Pripojiť',
      noFreeDisks: 'Žiadne nepoužité disky — vytvorte nejaký v časti Virtuálne stroje › Nepoužité disky.',
      addCdrom: 'Pridať mechaniku',
      addCdromTitle: 'Pridať mechaniku CD/DVD',
      editCdromTitle: 'Zmeniť obraz CD/DVD',
      changeMedia: 'Zmeniť obraz CD/DVD',
      ejectMedium: 'Vysunúť',
      mountGuestTools: 'Vložiť TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools vložené',
      guestToolsClickMount: 'Vloží ISO TVirt Guest Tools do prvej prázdnej mechaniky CD/DVD',
      guestToolsClickUnmount: 'Kliknutím vysuniete — mechanika zostáva, prázdna',
      guestToolsNoSlot: 'Žiadna prázdna mechanika CD/DVD — pridajte mechaniku (alebo vysuňte médium), aby sa dali vložiť TVirt Guest Tools',
      guestToolsSkew: 'Pripojená v{pinned}; uzol {node} teraz poskytuje v{current}: vysuňte a znovu pripojte pre aktualizáciu',
      ejectGuestTools: 'Vysunúť TVirt Guest Tools (mechanika zostáva, prázdna)',
      guestToolsEjectConfirmTitle: 'Vysunúť TVirt Guest Tools?',
      guestToolsEjectConfirmBody: 'Médium sa vysunie zo zapnutej VM — mechanika CD/DVD zostáva, prázdna.',
      applyLive: 'Použiť okamžite (VM je zapnutá)',
      addNic: 'Pridať rozhranie',
      addNicTitle: 'Pridať sieťové rozhranie',
      editNicTitle: 'Upraviť sieťové rozhranie',
      bridgeChip: 'bridge',
      cable: 'Virtuálny kábel',
      plug: 'Pripojiť virtuálny kábel',
      unplug: 'Odpojiť virtuálny kábel',
      remove: 'Odobrať',
      removeTitle: 'Odobrať {device}?',
      removeBody: 'Pri zapnutej VM sa zmena aplikuje pri najbližšom power cycle. Disky a obrazy sa odpájajú, nikdy sa neodstraňujú.'
    }
  }
}
